import type {FC} from 'react'
import React, {useCallback, useRef} from 'react'

import {FileList} from './FileList'
import {TargetBox} from './TargetBox'
import {HTML5Backend} from "react-dnd-html5-backend";
import {DndProvider} from "react-dnd";
import {IconTrash, IconUpload} from "@tabler/icons-react";

interface FileDropZoneProps {
    droppedFiles: File[],
    setDroppedFiles: React.Dispatch<React.SetStateAction<File[]>>,
    preview?: React.ReactNode,
    accept: string,
    btnText?: string,
}

// Da https://react-dnd.github.io/react-dnd/examples/other/native-files
// Vedera anche https://react-dropzone-uploader.js.org/
export const FileDropZone: FC<FileDropZoneProps> = ({droppedFiles, setDroppedFiles, preview, accept, btnText}) => {
    //const [droppedFiles, setDroppedFiles] = useState<File[]>([])
    const refFile = useRef<HTMLInputElement | null>(null);

    const handleFileDrop = useCallback(
        (item: { files: any[] }) => {
            if (item) {
                const files = item.files
                setDroppedFiles(files)
            }
        },
        [setDroppedFiles],
    )

    return (
        <>
            <input ref={refFile} type="file" accept={accept} style={{'display': 'none'}}
                   onChange={(event) => {
                       if (event.target.files) {
                           console.log(event.target.files[0]);
                           setDroppedFiles([event.target.files[0]]);
                       } else
                           setDroppedFiles([]);
                   }}
            />
            <DndProvider backend={HTML5Backend}>
                <div className="cursor-pointer" onClick={() => {
                    //console.log('click')
                    if (refFile && refFile.current) {
                        refFile.current.click();
                    }
                }}>
                    <TargetBox onDrop={handleFileDrop}/>
                </div>

                {preview && <div className="mt-4">{preview}</div>}
                {!preview && <FileList files={droppedFiles}/>}
            </DndProvider>
            {/*{droppedFiles.length > 0 && (*/}
            {droppedFiles.length > 0 && droppedFiles[0] !== undefined && (
                <div className="pt-4">
                    <button className="btnDanger"
                            onClick={() => {

                                if (refFile && refFile.current) {
                                    refFile.current.value = '';
                                }
                                setDroppedFiles([])

                            }}><IconTrash className="h-5 w-5"/>&nbsp;Rimuovi
                    </button>

                    {btnText &&
                        <button type="submit"
                                className="bg-blue-600 btnPrimary">
                            <IconUpload className="h-5 w-5"/><span>&nbsp;{btnText}</span>
                        </button>
                    }
                </div>
            )}
        </>
    )
}